<template>
  <div
    class="button-default"
    style="margin-top: 15px;"
  >
    <el-button
      style="margin-top: 0;"
      :class="{'button-default-disabled': disabled}"
      :disabled="disabled"
      :style="estiloBotao"
      @click="$emit('click')"
    >
      {{ title }}
    </el-button>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ButtonDefault',
  props: {
    title: {
      required: true,
      type: String
    },
    secundario: {
      type: Boolean
    },
    negativo: {
      type: Boolean
    },
    small: {
      type: Boolean
    },
    border: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo']),
    estiloBotao () {
      if (this.estilo && this.estilo.botaoPrincipal) {
        const style = {
          'background': `${this.estilo.botaoPrincipal.corBotaoPrincipal}`,
          'color': `${this.estilo.botaoPrincipal.corTextoBotaoPrincipal}`
        }
        if (this.secundario) {
          style.background = `${this.estilo.botaoSecundario.corBotaoSecundario}`
          style.color = `${this.estilo.botaoSecundario.corTextoBotaoSecundario}`
        }
        if (this.negativo) {
          style.background = `${this.estilo.botaoNegativo.corBotaoNegativo}`
          style.color = `${this.estilo.botaoNegativo.corTextoBotaoNegativo}`
        }
        if (this.small) {
          style.fontSize = '11px'
          style.minHeight = '30px'
          style.lineHeight = '15px'
          style.width = 'unset'
          style.padding = '7px 12px'
        }
        if (this.border) {
          style.border = `1px solid ${this.estilo.botaoSecundario.corTextoBotaoSecundario}`
        }
        return style
      } else {
        return ''
      }
    }
  }
}
</script>
